__turbopack_context__.v({
  "checkIcon": "R-bdhq_checkIcon",
  "label": "R-bdhq_label",
  "labelContainer": "R-bdhq_labelContainer",
  "labelYou": "R-bdhq_labelYou",
  "root": "R-bdhq_root",
});
